import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';
import button from 'bootstrap/js/src/button';
import _get from 'lodash/get';
import {QRCodeSVG} from 'qrcode.react';
import FormattedDate from '../../../../components/product/FormattedDate';

export default function PreviewQrCode({actionBtns, show, setShow}) {
  const previewLink = _get(actionBtns, 'preview_link');
  const lastGenerated = _get(actionBtns, 'last_generated');
  return (
    <>
      <Modal size="l" show={show} centered={true} onHide={() => setShow(false)}>
        <Modal.Header>
          <Modal.Title>
            <Trans i18nKey="p.s.c.customization.app.preview.qr.code">
              App Preview QR Code
            </Trans>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            <Trans i18nKey="p.s.c.customization.app.preview.qr.code.desc1">
              The latest UI Configuration edits are ready for preview.
              <br />
              Scan the QR code with the <b>Y4B in-app scanner</b> to preview the
              updates in the app.
            </Trans>
          </p>
          <p className="text-muted">
            <Trans i18nKey="p.s.c.customization.app.preview.qr.code.desc1.note">
              Note: If you receive a report via email while in preview mode, the
              email content and links will reflect the online version, not the
              preview version.
            </Trans>
          </p>
          <p>
            <Trans i18nKey="p.s.c.customization.app.preview.qr.code.desc2">
              This QR code is for preview only.
              <br />
              Click <b>"Publish to Online"</b> after confirming the preview to
              apply the updates online.
            </Trans>
          </p>
          {previewLink && (
            <div className="d-flex align-items-end">
              <QRCodeSVG value={previewLink} />
              &nbsp;
              {lastGenerated && (
                <span>
                  <Trans i18nKey="p.s.c.customization.app.preview.qr.code.gnertate">
                    Generated from edits on:
                  </Trans>
                  &nbsp;
                  <FormattedDate time={lastGenerated} type={'long'} />
                </span>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-outline-secondary kt-margin-r-10"
              onClick={() => {
                setShow(false);
              }}
            >
              <Trans i18nKey="p.p.s.view.close">Close</Trans>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
